import { render, staticRenderFns } from "./ReadOnlyAmendment.vue?vue&type=template&id=2e828619&"
import script from "./ReadOnlyAmendment.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyAmendment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports